import { Stack, Typography } from '@mui/material';

// Components
import { IContributeDetailCompany } from 'src/utils/typings/response/contribute';
import ListImages from 'src/components/common/ListImages';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';

const AddressesCompany = ({ dataContribution }: { dataContribution: IContributeDetailCompany }) => {
  let listImages: ImageContribute[] = [];
  switch (dataContribution?.type_of_contribution) {
    case TypeContributeCompany.AlternativeAddressCompany:
      listImages = getArrayDefault(dataContribution.contribution_alternative_address_company_profile);
      break;
    case TypeContributeCompany.PrimaryAddressCompany:
      listImages = getArrayDefault(dataContribution.contribution_primary_address_company_profile);
      break;
    case TypeContributeCompany.RegisteredAddressCompany:
      listImages = getArrayDefault(dataContribution.contribution_registered_address_company_profile);
      break;
    default:
      break;
  }
  const photos = getArrayDefault(listImages).map((img) => ({
    url: img?.url || '',
  }));
  return (
    <Stack spacing={2} flex={1}>
      <Typography align="left" variant="subtitle1" color="text.main">
        A few pictures
      </Typography>
      <ListImages listImg={photos} showBtnAddMoreImg={false} widthImg={80} limit={photos.length} />
    </Stack>
  );
};

export default AddressesCompany;
